// extracted by mini-css-extract-plugin
export var formContainer = "_cc-0";
export var message = "_cc-1";